<template>
  <div class="chargeback" id="secCheckout">
    <me-loading :loading="loading"></me-loading>

    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <div class="chargeback__container">
      <h2 class="chargeback__heading">Uma contestação de pagamento foi solicitada</h2>
      <p class="chargeback__subtitle">Sua conta está temporariamente bloqueada por motivos de segurança</p>
      <p class="chargeback__text">Nosso sistema identificou que houve um chargeback. Isso significa que a operadora de cartão de crédito que você utilizou para inserir saldo ou gerar etiquetas no Melhor Envio contestou um pagamento. Por causa disso, sua conta foi temporariamente bloqueada. Esse é um procedimento padrão de prevenção, ok? Você poderá seguir usando a plataforma normalmente assim que desbloquear sua conta.</p>

      <div class="chargeback__content">
        <div class="chargeback__description">
          <p class="chargeback__title chargeback__title--description">Como desbloquear sua conta?</p>
          <p class="chargeback__text chargeback__text--description">É necessário pagar o débito gerado pelo chargeback. Abaixo, você encontra os dados de pagamento que foram contestados e um botão para emitir um boleto. Tenha em mente que esse débito só pode ser pago via boleto e que o prazo de processamento é de até 24h úteis.</p>
          <div class="chargeback__alert">
            <svg class="chargeback__icon chargeback__icon--description"><use xlink:href="/images/svg-symbols.svg#cgb_alert"></use></svg>
            <div class="chargeback__description">
              <p class="chargeback__subtitle chargeback__subtitle--left">Evite transtornos!</p>
              <p class="chargeback__text chargeback__text--tiny">Seus envios em trânsito podem ser interceptados se a situação não for regularizada em até 2 dias úteis.</p>
            </div>
          </div>
        </div>
        <svg class="chargeback__ilustration"><use xlink:href="/images/svg-symbols.svg#cgb_ilustration"></use></svg>
      </div>

      <div class="chargeback__card">
        <table class="chargeback__table">
          <thead>
            <tr class="chargeback__table--row">
              <th class="chargeback__table--heading">Protocolo</th>
              <th class="chargeback__table--heading">Data do Pagamento</th>
              <th class="chargeback__table--heading">Valor</th>
              <th class="chargeback__table--heading"></th>
            </tr>
          </thead>

          <tbody class="chargeback__table--body">
            <tr class="chargeback__table--row" v-for="pay in getChargebackPayments" :key="pay.paymentSourceChargeback.id">
              <td class="chargeback__table--item">{{ pay.paymentSourceChargeback.protocol }}</td>
              <td class="chargeback__table--item">{{ pay.paymentSourceChargeback.transaction.authorized_at | dateFormat }}</td>
              <td class="chargeback__table--item chargeback__table--value">{{ pay.paymentSourceChargeback.value | currency }}</td>
              <td class="chargeback__table--item">
                <div v-if="pay.paymentToPay.response">
                  <div
                    v-if="pay.paymentToPay.status === 'unauthorized' || pay.paymentToPay.status === 'canceled'"
                    class="chargeback__buttons chargeback__buttons--column"
                  >
                    <p class="chargeback__text chargeback__text--expire">Boleto expirado</p>
                    <a class="chargeback__button--link" href="javascript:;" @click="checkout(pay.paymentToPay.id)">Gerar novo boleto</a>
                  </div>
                  <div v-else>
                    <div class="chargeback__buttons">
                      <!-- <me-tooltip :message.sync="copyMessage">
                        <svg
                          class="chargeback__button--icon"
                          @click="copyCode(pay.paymentToPay.id)"
                          @mouseleave="resetMessage()"
                        >
                          <use xlink:href="/images/svg-symbols.svg#cgb_copy"></use>
                        </svg>
                      </me-tooltip> -->

                      <me-tooltip message="Imprimir">
                        <a :href="$sanitizeUrl(pay.paymentToPay.link)" target="__BLANK" rel="noopener noreferrer">
                          <svg class="chargeback__button--icon"><use xlink:href="/images/svg-symbols.svg#cgb_printer"></use></svg>
                        </a>
                      </me-tooltip>
                      <input
                        :id="`cb-${pay.paymentToPay.id}`"
                        class="chargeback__code--hidden"
                        :value="pay.paymentToPay.response.bank_slip ? pay.paymentToPay.response.bank_slip.digitable_line : pay.paymentToPay.response.digitable"
                      />
                    </div>
                  </div>
                </div>
                <a
                  v-else
                  href="javascript:;"
                  @click="checkout(pay.paymentToPay.id)"
                  class="chargeback__button chargeback__button--brick"
                >
                  gerar boleto
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <ul v-for="pay in getChargebackPayments" :key="pay.paymentSourceChargeback.id" class="chargeback__list">
          <li class="chargeback__list__row chargeback__list__row--1">
            <div class="chargeback__item--protocol">
               <p class="chargeback__tile">Protocolo</p>
               <p class="chargeback__subtile">{{ pay.paymentSourceChargeback.protocol }}</p>
            </div>
            <div class="chargeback__item--date">
              <p class="chargeback__tile">Data do Pagamento</p>
              <p class="chargeback__subtile chargeback__subtile--right">{{moment(pay.paymentSourceChargeback.authorized_at).format('DD/MM/yyyy')}}</p>
            </div>
          </li>

          <li class="chargeback__list__row chargeback__list__row--2">
            <div class="chargeback__item--value">
              <p class="chargeback__tile">Valor</p>
              <p class="chargeback__subtile chargeback__subtile--value">{{ pay.paymentSourceChargeback.value | currency }}</p>
            </div>
            <div class="chargeback__item--action">
              <div v-if="pay.paymentToPay.response" class="chargeback__list__column">
                <div v-if="pay.paymentToPay.status === 'unauthorized' || pay.paymentToPay.status === 'canceled'" class="chargeback__list__column">
                  <p class="chargeback__text chargeback__text--expire">Boleto expirado</p>
                  <a class="chargeback__button--link" href="javascript:;" @click="checkout(pay.paymentToPay.id)">Gerar novo boleto</a>
                </div>

                <div v-else>
                  <div class="chargeback__buttons">
                    <!-- <a
                      class="chargeback__button--icon"
                      href="javascript:;"
                      @click="copyCode(`${pay.paymentToPay.id}-mobile`, 'molile')"
                      @mouseleave="resetMessage()"
                    >
                      <svg class="chargeback__icon--button"><use xlink:href="/images/svg-symbols.svg#cgb_copy"></use></svg>
                      <span class="chargeback__button--text">Copiar código</span>
                    </a> -->
                    <a class="chargeback__button--icon" :href="$sanitizeUrl(pay.paymentToPay.link)" target="__BLANK" rel="noopener noreferrer">
                      <svg class="chargeback__icon--button"><use xlink:href="/images/svg-symbols.svg#cgb_printer"></use></svg>
                      <span class="chargeback__button--text">Imprimir</span>
                    </a>

                    <input
                      :id="`cb-${pay.paymentToPay.id}-mobile`"
                      class="chargeback__code--hidden"
                      :value="pay.paymentToPay.response.bank_slip ? pay.paymentToPay.response.bank_slip.digitable_line : pay.paymentToPay.response.digitable"
                    />
                  </div>
                </div>

              </div>
              <a
                v-else
                href="javascript:;"
                @click="checkout(pay.paymentToPay.id)"
                class="chargeback__button chargeback__button--brick"
              >
                gerar boleto
              </a>
            </div>
          </li>

        </ul>

        <div class="chargeback__divider"></div>

        <div class="chargeback__footer">
          <svg class="chargeback__icon chargeback__icon--footer"><use xlink:href="/images/svg-symbols.svg#cgb_alert"></use></svg>
          <p class="chargeback__text chargeback__text--footer">Lembre-se: sua conta só será liberada após o pagamento de todos os débitos listados. Os pagamentos feitos por boleto bancário podem levar até 24 horas úteis para serem reconhecidos.</p>
        </div>
      </div>

      <p class="chargeback__text chargeback__text--coal">Caso você acredite que tenha ocorrido um erro no sistema, <a :href="supportDashUrl" target="_blank">entre em contato com o nosso suporte</a>.</p>
    </div>

    <transition name="fade">
      <div class="modal modal--small modal--center" v-if="modalAlert">
        <div class="modal__header">
          <p>{{ modalAlertHeader }}</p>

          <a href="javascript:;" class="closeModal"><svg class="ico" @click="hideModal('modalAlert')"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="modal__content">
          <p>{{ modalAlertText }}</p>
        </div>
        <div class="modal__footer">
          <button name="Tentar novamente" type="button" class="btnBorder btnBorder--small" @click="hideModal('modalAlert')"><span>Tentar novamente</span></button>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="chargeback__modal" v-if="modalBoleto">
        <div class="chargeback__modal__header">
          <a href="javascript:;"><svg class="chargeback__icon--close" @click="hideModal('modalBoleto')"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="chargeback__modal__container">
          <p class="chargeback__title">Imprimir boleto</p>
          <p class="chargeback__text chargeback__text--center">Clique no botão abaixo ou utilize o código para pagar o seu boleto.</p>
          <div class="chargeback__row chargeback__row--modal">
            <input :id="'cb-'+paymentId" class="chargeback__code" :value="codBoleto" readonly />
            <me-tooltip :message.sync="copyMessage">
              <a
                class="chargeback__button--icon"
                href="javascript:;"
                @click="copyCode(paymentId)"
                @mouseleave="resetMessage()"
              >
                <svg class="chargeback__icon--button"><use xlink:href="/images/svg-symbols.svg#cgb_copy"></use></svg>
              </a>
            </me-tooltip>
          </div>

        </div>
        <div class="chargeback__modal__footer">
          <a :href="$sanitizeUrl(lnkBoleto)" target="_blank" class="chargeback__button chargeback__button--print" rel="noopener noreferrer"><span>Imprimir</span></a>
        </div>
      </div>
    </transition>
    <me-stacked-toast ref="toast"/>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import Tooltip from "commons/js/components/atoms/Tooltip.vue";
import StackedToast from "commons/js/components/atoms/StackedToast.vue";


  export default {
    props: {
      payments: Array,
      totalDebts: {
        type: String,
        required: true
      }
    },

    components: {
      'me-tooltip': Tooltip,
      'me-stacked-toast': StackedToast
    },

    data() {
      return {
        chargebakcs: [],
        modalBoleto: false,
        lnkBoleto: '',
        codBoleto: '',
        paymentId: '',

        loading: false,
        showMask: false,
        showMessage: false,

        modalAlert: false,
        modalAlertHeader: 'Atenção!',
        modalAlertText: '',
        modalAlertButton: 'Tentar novamente',
        modalAlertActionButton: '',
        modalAlertActionFunction: () => {},

        copyMessage: 'Copiar código',
        supportDashUrl: ''
      }
    },

    computed: {
      ...mapGetters('chargeback', ['getChargebackPayments'])
    },

    async mounted() {
      await this.loadDebits();
      this.supportDashUrl = MEConfig.get('dash.url') + '/ajuda';
    },

    filters: {
      dateFormat (value, format = 'DD/MM/YYYY') {
        if (!value) {
          return '-'
        }

        return moment(value).format(format)
      },

      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);

        let matches = value.match(/(\,|\.)(\d{2})$/);

        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);

        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';

        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
    },

    watch: {
      copyMessage() {
        if(this.message !== 'Copiar código') {
          this.copyMessage = this.copyMessage;
        }
      }
    },

    methods: {
      ...mapActions('chargeback', ['setChargebackPayments']),

      copyCode(id, mobile) {
        document.querySelector(`#cb-${id}`).select();
        document.execCommand("copy");

        if(mobile) {
          this.$refs.toast.createToast('Código copiado', 'success');
        }

        this.copyMessage = 'Código copiado';
      },

      resetMessage() {
        this.copyMessage = 'Copiar código';
      },

      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
      },

      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
        this.loading = true;
        location.reload();
      },

      hideAllModals() {
        this.showMask = false;
        this.modalAlert = false;
        this.modalBoleto = false;
         this.loading = true;
        location.reload();
      },

      async loadDebits() {
        const debits = await this.getChargebackPayments;

        if(debits.length <= 0) {
          this.setChargebackPayments(this.payments);
        }
      },

      async checkout(payment_id) {
        this.loading = true;

        try {
          const generateFingerprint = window.yapay && window.yapay.FingerPrint();
          const fingerprint = generateFingerprint && generateFingerprint.getFingerPrint();

          const res = await axios.post('/api/v2/me/chargeback/checkout', {
            payment_id,
            ...(fingerprint ? {finger_print: fingerprint} : null)
          });

          this.loading = false;
          this.showModal('modalBoleto');
          this.lnkBoleto = res.data.redirect;
          this.codBoleto = res.data.digitable;
          this.paymentId = payment_id;
        } catch (error) {
          this.loading = false;

          if (error.response.data && error.response.data.hasOwnProperty('error')) {
            this.showModal('modalAlert');
            this.modalAlertText = error.response.data.error;
          } else if (error.response.status === 403) {
            this.showModal('modalAlert');
            this.modalAlertText = 'Você não possuí permissão para adicionar créditos, confirme seus dados.';
          } else {
            this.showModal('modalAlert');
            this.modalAlertText = 'Erro ao adicionar créditos.';
          }
        }
      },

      moment,
    }
  }
</script>
